/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Er as Er,
  rec_Fo as Fo,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_Modal as Modal,
  rec_Pr as Pr,
  rec_React as React,
  rec_Ro as Ro,
  rec_Yx as Yx,
  rec_aS as aS,
  rec_api as api,
  rec_ii as ii,
  rec_pS as pS,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function DetalleReunion({
  id: e,
  onClose: t,
  onCrearTarea: n,
  onCambio: r,
  soloLectura: i,
}) {
  let { confirmar: a } = Fo(),
    [o, s] = (0, React.useState)(null),
    [c, l] = (0, React.useState)(``),
    [u, f] = (0, React.useState)(``);
  (0, React.useEffect)(() => {
    api(`/reuniones/${e}`)
      .then((e) => {
        (s(e), l(e.acta || ``));
      })
      .catch((e) => f(e.message));
  }, [e]);
  async function p() {
    try {
      (await api(`/reuniones/${e}`, {
        method: `PUT`,
        body: JSON.stringify({
          ...o,
          acta: c,
          estado: `REALIZADA`,
        }),
      }),
        t());
    } catch (e) {
      f(e.message);
    }
  }
  async function m() {
    if (
      await a({
        titulo: `Eliminar la serie completa`,
        mensaje: `Se borran TODAS las reuniones de esta serie recurrente, no solo esta. No se puede deshacer.`,
        confirmarTexto: `Eliminar la serie`,
        peligro: !0,
      })
    )
      try {
        (await api(`/reuniones/serie/${o.serieId}`, {
          method: `DELETE`,
        }),
          r?.(),
          t());
      } catch (e) {
        f(e.message);
      }
  }
  return (
    <Modal
      titulo={o?.titulo ?? `Reunion`}
      onClose={t}
      ancho={`max-w-xl`}
      children={[
        u && <p className={`text-sm text-(--error)`} children={u} />,
        o ? (
          <div
            className={`flex flex-col gap-3 text-sm`}
            children={[
              <p
                className={`text-(--text)`}
                children={[
                  pS(o.fechaHora),
                  ` · `,
                  Yx(o.modalidad),
                  o.lugarOEnlace ? ` · ${o.lugarOEnlace}` : ``,
                ]}
              />,
              o.sedes?.length > 1 && (
                <p
                  className={`text-xs text-(--text)`}
                  children={[
                    `Sedes `,
                    o.sedes.map((e) => e.nombre).join(` y `),
                  ]}
                />
              ),
              aS(o) && (
                <a
                  href={aS(o)}
                  target={`_blank`}
                  rel={`noreferrer`}
                  className={`inline-flex w-fit items-center gap-1.5 rounded-full border border-(--border) bg-(--social-bg) px-3 py-1.5 text-xs font-medium text-(--text-h) transition hover:opacity-80`}
                  children={[
                    <Er className={`h-3.5 w-3.5`} />,
                    ` Registrar en Teams`,
                  ]}
                />
              ),
              o.agenda && (
                <div
                  children={[
                    <p
                      className={`text-xs font-semibold text-(--text)`}
                      children={`AGENDA`}
                    />,
                    <p
                      className={`whitespace-pre-wrap text-(--text-h)`}
                      children={o.agenda}
                    />,
                  ]}
                />
              ),
              <div
                children={[
                  <p
                    className={`text-xs font-semibold text-(--text)`}
                    children={`PARTICIPANTES`}
                  />,
                  <p
                    className={`text-(--text-h)`}
                    children={
                      o.participantes.map((e) => e.usuarioNombre).join(`, `) ||
                      `—`
                    }
                  />,
                ]}
              />,
              <div
                children={[
                  <div
                    className={`flex items-center justify-between`}
                    children={[
                      <p
                        className={`text-xs font-semibold text-(--text)`}
                        children={`TAREAS QUE SE PLANTEARON AQUI`}
                      />,
                      !i && (
                        <button
                          type={`button`}
                          onClick={() =>
                            n({
                              reunionOrigenId: o.id,
                              reunionOrigenTitulo: o.titulo,
                            })
                          }
                          className={`flex items-center gap-1 text-xs font-medium text-(--accent) hover:underline`}
                          children={[
                            <Pr className={`h-3.5 w-3.5`} />,
                            ` Crear tarea acordada`,
                          ]}
                        />
                      ),
                    ]}
                  />,
                  o.tareasOriginadas?.length > 0 ? (
                    <ul
                      className={`mt-1 list-inside list-disc text-(--text-h)`}
                      children={o.tareasOriginadas.map((e) => (
                        <li
                          key={e.id}
                          children={[
                            e.titulo,
                            ` `,
                            <span
                              className={`text-xs text-(--text)`}
                              children={[`(`, Yx(e.estado), `)`]}
                            />,
                          ]}
                        />
                      ))}
                    />
                  ) : (
                    <p
                      className={`mt-1 text-xs text-(--text)`}
                      children={`Ninguna todavia.`}
                    />
                  ),
                ]}
              />,
              <label
                className={`text-xs font-semibold text-(--text)`}
                children={[
                  `ACTA / ACUERDOS`,
                  <textarea
                    className={`${Lo} mt-1 min-h-24`}
                    value={c}
                    onChange={(e) => l(e.target.value)}
                    disabled={i}
                  />,
                ]}
              />,
              <div
                className={`flex items-center justify-between gap-2`}
                children={[
                  !i && o.serieId ? (
                    <button
                      type={`button`}
                      onClick={m}
                      className={`text-xs font-medium text-(--error) hover:underline`}
                      children={`Eliminar toda la serie`}
                    />
                  ) : (
                    <span />
                  ),
                  <div
                    className={`flex gap-2`}
                    children={[
                      <button
                        type={`button`}
                        onClick={t}
                        className={zo}
                        children={`Cerrar`}
                      />,
                      !i && (
                        <button
                          type={`button`}
                          onClick={p}
                          className={Ro}
                          children={`Guardar acta`}
                        />
                      ),
                    ]}
                  />,
                ]}
              />,
            ]}
          />
        ) : (
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          })
        ),
      ]}
    />
  );
}
